import React from "react";
import { Grid } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Controller } from "react-hook-form";
import DateFnsUtils from "@date-io/date-fns";
import { ptBR } from "date-fns/locale";

const TermsSegment = props => {
  const { control, errors } = props;

  return (
    <Grid item container xs={4}>
      <Grid item xs={12}>
        <Controller
          name="termsAcceptedAt"
          control={control}
          render={({ field: { ref, onChange, ...fieldProps } }) => {
            return (
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                <KeyboardDatePicker
                  autoComplete="off"
                  clearable
                  clearLabel="LIMPAR"
                  disableFuture
                  inputRef={ref}
                  {...fieldProps}
                  onChange={date => onChange(date || null)}
                  fullWidth
                  label="Data de assinatura dos termos"
                  variant="outlined"
                  format="dd/MM/yyyy"
                  inputVariant="outlined"
                  cancelLabel="CANCELAR"
                  KeyboardButtonProps={{
                    "aria-label": "Selecione uma data"
                  }}
                  inputProps={{
                    "aria-label": "Selecione a data de assinatura dos termos"
                  }}
                  InputLabelProps={{ shrink: true }}
                  error={errors && !!errors[fieldProps.name]}
                  helperText={
                    errors && errors[fieldProps.name]
                      ? errors[fieldProps.name].message
                      : null
                  }
                />
              </MuiPickersUtilsProvider>
            );
          }}
        />
      </Grid>
    </Grid>
  );
};

export default TermsSegment;
